import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Acción asincrónica para crear una preferencia de pago en MercadoPago
export const createPaymentPreference = createAsyncThunk(
  'payments/createPaymentPreference',
  async (args, thunkAPI) => {
    const { paymentData } = args;
    const { rejectWithValue } = thunkAPI;

    try {
      const response = await axios.post(`/mercadopago/crear-preferencia`, paymentData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const paymentSlice = createSlice({
    name: 'payments',
    initialState: {
        preferenceId: null,  // Almacenará el ID de la preferencia de MercadoPago
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createPaymentPreference.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createPaymentPreference.fulfilled, (state, action) => {
                state.preferenceId = action.payload.id; // Guardamos el ID de la preferencia
                state.loading = false;
            })
            .addCase(createPaymentPreference.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default paymentSlice.reducer;
